import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@edx/frontend-platform/i18n';

const ProviderProctoredExamInstructions = ({
  providerName, supportEmail, supportPhone, instructions,
}) => (
  <>
    <ol>
      {instructions.map((item, index) => (
        <li key={index.toString()}>
          {item}
        </li>
      ))}
    </ol>
    {supportEmail && supportPhone && (
      <p>
        <FormattedMessage
          id="exam.DownloadSoftwareProctoredExamInstructions.supportText"
          defaultMessage={'If you have issues relating to proctoring, you can contact '
          + '{providerName} technical support by emailing {supportEmail} or by calling {supportPhone}.'}
          values={{
            providerName,
            supportEmail,
            supportPhone,
          }}
        />
      </p>
    )}
  </>
);

ProviderProctoredExamInstructions.propTypes = {
  providerName: PropTypes.string,
  supportEmail: PropTypes.string,
  supportPhone: PropTypes.string,
  instructions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ProviderProctoredExamInstructions.defaultProps = {
  providerName: '',
  supportEmail: '',
  supportPhone: '',
};

export default ProviderProctoredExamInstructions;
